export default __webpack_public_path__ + "static/media/main.8c4e2d08.png";